module.exports = __webpack_public_path__ + "static/home1-banner-sizes-1099a219238896bc38c75743fb3cdc5e.png";